import { paramCase } from "change-case"

import DomUtils from "../utils/dom-utils"
import Utils from "../utils/utilities"

import { WINDOW } from "../utils/window-utils"
import { getKey, interpolator, domParser } from "../constants/bind-functions"

const showHide: Function = (elementString: string, values: any) => {
    return elementString.replace(/\n/g, '').replace(/(\{\{\!-- if(.*?)(endif\s\}\}))/gm, entry => {
        const matches: RegExpExecArray = /\{\{\!-- if\s(.*)\s\}\}(.*)\{\{\!--\sendif\s\}\}/gm.exec(entry)

        if (Utils.isDefined(matches) && matches.length > 2) {
            const match: any = Utils.safeGetIncArr(values, matches[1])
            if (Utils.isDefined(match)) return matches[2]
        }

        return ''
    })
}

const inserter: Function = (elementString: string, initialElement: Comment, interpolateObj: any): Element => {
    const doc: Document = domParser.parseFromString(interpolator.parse(elementString, interpolateObj), 'text/html')
    const el: any = doc.body.firstChild
    const res: Element = initialElement.parentNode.insertBefore(el, initialElement)

    return res
}

const bindList: Function = (value: Array<any>, comments: Array<Comment>, elems: Array<Array<Element>>): Array<Array<Element>> => {
    return comments.map((comment: any, index: number) => {
        const elementString: string = comment.data
        const result: Array<Element> = value.map((v, index) => {
            if (typeof v === 'string') {
                const insertable: any = { text: v, index: index.toString(), count: (index + 1).toString() }

                return inserter(showHide(elementString, insertable), comment, insertable)
            } else {
                const insertable: any = Object.assign({}, v)
                insertable.index = index.toString()
                insertable.count = (index + 1).toString()

                return inserter(showHide(elementString, insertable), comment, insertable)
            }
        })

        if (elems != undefined && elems.length > 0) {
            elems[index].forEach(e => {
                if (e.remove) {
                    e.remove()
                }
            })
        }

        return result
    })
}

export default function BindToList(target: any, key: string): any {
    const elementsToBind: Array<Element> =
        DomUtils.selectAllByQuery(WINDOW.nativeWindow.document, `[${paramCase(key)}]`)
    const bindingComments: Array<Comment> = elementsToBind.map(element => {
        const beforeComment: Comment = document.createComment(`Bound to ${key} in ${target.constructor}`)
        const afterComment: any = document.createComment(element.outerHTML)
        element.parentElement.insertBefore(beforeComment, element)
        element.parentElement.insertBefore(afterComment, element)
        element.parentElement.removeChild(element)

        return afterComment
    })

    let boundList: Array<Array<Element>> = []

    return {
        set: function (value) {
            this[getKey(key)] = value

            if (Utils.isDefined(value)) {
                boundList = bindList(value, bindingComments, boundList)
            }
        },
        get: function() {
            return this[getKey(key)]
        },
        enumerable: true,
        configurable: true
    }
}